import { useChargeItems } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { ChargeItemAttributes } from '@type/chargeItem.type'
import { CheckBox, FormButton, FormInputField, Modal, TextAreaField } from '@ui'
import { getError, showToast } from '@util'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'

type Props = {
  onClose: () => void
  defaultData?: ChargeItemAttributes
  id?: string
}

const addChargeItemSchema = yup.object({
  name: yup.string().required('Name is required'),
  description: yup.string(),
  amount: yup.number().required('Amount is required'),
  auto_apply: yup.boolean()
})

export const AddChargeItem = ({ onClose, defaultData, id }: Props) => {
  const methods = useForm({ resolver: yupResolver(addChargeItemSchema), values: defaultData })
  const {
    handleSubmit,
    reset,
    formState: { isSubmitting }
  } = methods

  const handleClose = () => {
    onClose()
    reset()
  }
  const { createChargeItem, updateChargeItem } = useChargeItems()

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data
        },
        type: 'charge_item'
      }
    }
    console.log(data)
    try {
      if (id) {
        await updateChargeItem({ formVal: payload, id })
      } else {
        await createChargeItem(payload)
      }
      showToast(id ? 'Charge item updated successfully' : 'Charge item added successfully')
      handleClose()
    } catch (error) {
      getError(error)
    }
  }

  return (
    <FormProvider {...methods}>
      <Modal onClose={handleClose} reset={reset} title={id ? 'Edit Charge Item' : 'Add Charge Item'}>
        <form className="flex flex-col overflow-auto" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-y-4 overflow-auto p-6">
            <div className="mx-auto flex w-full max-w-[399px] flex-col gap-4">
              <div className="">
                <FormInputField label="Name" name="name" placeholder="E.g Paracetamol" />
              </div>
              <div className="">
                <FormInputField label="Amount" name="amount" placeholder="E.g 100" suffix="₦" type="number" />
              </div>
              <div className="">
                <TextAreaField label="Description" name="description" />
              </div>
              <Controller
                control={methods.control}
                name="auto_apply"
                render={({ field }) => (
                  <div className="flex gap-1 items-center">
                    <CheckBox
                      defaultCheck={field?.value}
                      handleChange={arg => {
                        field.onChange(arg)
                      }}
                      label="Auto Apply"
                    />
                  </div>
                )}
              />
            </div>
          </div>
          <FormButton isLoading={isSubmitting} onClose={handleClose} submit={id ? 'Update' : 'Add'} />
        </form>
      </Modal>
    </FormProvider>
  )
}
